<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectOrderBy" });
import { SelectSingle } from "../../../../selects/index.js";
import Button from "../../../../elements/button/Button.svelte";
import { ORDER_OPTIONS } from "../../config/order.js";
import { t } from "svelte-i18n";
export let orderBy;
export let direction;
const addLabels = ({ key, label }) => ({ key, label: $t(label) });
const toggleDirection = () => {
    direction = direction === "asc" ? "desc" : "asc";
};
$: OPTIONS = ORDER_OPTIONS.map(addLabels);
</script>

<div class = 's8-select-order'>

    <Button
        on:click = { toggleDirection }
        icon = { direction === 'asc' ? 'arrowUp' : 'arrowDown' }
        style = 'ghost'
        color = 'dark'
        size = 'sm'
    />

    <SelectSingle
        bind:key = { orderBy }
        name = 'auction.order_by.option'
        options = { OPTIONS }
        isDisabled = { false }
        isRequired = { false }
        label = { null }
    />

</div>

<style>
    div.s8-select-order {
        display: flex;
        -moz-column-gap: 10px;
             column-gap: 10px;
        align-items: center;
    }

        div.s8-select-order :global(div.s8-input) {
            margin-bottom: 0px;
            width: 160px;
        }

        div.s8-select-order :global(div.s8-input div.s8-footer) {
            display: none;
        }</style>